requestIdleCallback(() => {
  if (!customElements.get('lookbook-section')) {
    class LookbookSection extends HTMLElement {
      constructor() {
        super();
        
        this.items = this.querySelectorAll('.lookbook__item');
        this.columns = this.querySelectorAll('.lookbook__column');

        this.items.forEach((element, index) => {
          element.addEventListener('mouseenter', () => {
            this.columns[index].classList.add('active');
          });
          element.addEventListener('mouseleave', () => {
            this.columns[index].classList.remove('active');
          });
        });

        this.columns.forEach((element, index) => {
          element.addEventListener('mouseenter', () => {
            this.items[index].classList.add('active');
          });
          element.addEventListener('mouseleave', () => {
            this.items[index].classList.remove('active');
          });
        });
      }
    }

    customElements.define('lookbook-section', LookbookSection);
  }
});